export default function LoaderFullScreen() {
    return (
        <div id="loader">
            <div className="spinner-border text-primary" role="status"></div>
        </div>
    );
}